import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Space, Table, Button, Input } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { debounce } from "lodash";

import { PAGE_LENGTH } from "../../config";
import Loader from "../loader";
import ImportLeads from "./ImportLeads";
import FeatureComingSoon from "../../common/FeatureComingSoon";
import {
  getExecutiveEmployeeList,
  saveAdvancedSelectedFilters,
  savePaginationValues,
} from "../../actionCreator/leadListingActionCreater";
import { getUserInfo } from "../../utils/utils";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const { Search } = Input;

const items = [
  {
    key: "1",
    label: "Quick Create",
  },
  {
    key: "2",
    label: "Import",
  },
];

const LeadTableView = ({
  calendarShow,
  checkPageLayout,
  tagPage,
  downloadExcel,
  downloadPDF,
  printPage,
  loading,
  rowSelection,
  columns,
  executiveEmployeeList,
  paginationValue,
  companyFilterList,
  onPageChange,
  handleAddLeadsForm,
}) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { isLeadCreate } = useContext(AuthContext);
  const [isImport, setImport] = useState(false);
  const leadSelectedFilterList = useSelector(
    (state) => state.leadListingReducer.selectedFilters
  );

  const handleMenuClick = (e) => {
    if (e.key === "1") {
      if (isLeadCreate) {
        handleAddLeadsForm();
      } else {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to create lead."
        );
      }
    }
    if (e.key === "2") {
      setImport(true);
    }
  };

  const onSearch = debounce((event) => {
    const payload = {
      ...leadSelectedFilterList,
      searchKeyword: event?.target?.value,
    };
    const pageValues = {
      start: 0,
      end: PAGE_LENGTH,
    };
    dispatch(savePaginationValues(pageValues));
    dispatch(saveAdvancedSelectedFilters(payload));
    dispatch(getExecutiveEmployeeList(payload, pageValues));
  }, 500);

  const currentPage = paginationValue.start + 1;
  const itemsPerPage = paginationValue.end;
  const totalItems = companyFilterList?.totalExecutiveCount;
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <>
      <div className="contentbody shadow">
        <div id="content-wrapper" className="d-flex flex-column ">
          <div id="content" className="shadow">
            <div className="container-fluid pl-0 pr-0">
              <div className="row">
                <div className="col-xl-12 col-lg-10 pl-0">
                  <div className="card shadow mb-4">
                    <div className="card-header py-3 f-rev d-flex align-items-center justify-content-between">
                      {!!totalItems && (
                        <h6 className="m-0 ml-2 font-weight-bold text-primary mob-t">
                          Showing {startItem}-{endItem}
                          <span className="m-1">of</span>{" "}
                          {companyFilterList?.totalExecutiveCount}
                          <span className="m-1">results</span>
                        </h6>
                      )}
                      <span className="ml-4 fs-23 mr-3">
                        <i
                          className=" las la-calendar-day"
                          onClick={calendarShow}
                          aria-hidden="true"
                        ></i>
                        <i
                          className=" btn  mr-3 ml-3 kanbanlist"
                          onClick={() => checkPageLayout(1)}
                        ></i>
                        <i
                          className=" btn  kanbanview"
                          onClick={() => checkPageLayout(2)}
                        ></i>
                      </span>

                      <Dropdown
                        menu={{
                          items,
                          selectable: true,
                          defaultSelectedKeys: ["2"],
                          onClick: handleMenuClick,
                        }}
                      >
                        <Button>
                          <Space>
                            <i className=" fs-14 font-weight-bold fa fa-plus"></i>
                            Add Lead
                            <DownOutlined />
                          </Space>
                        </Button>
                      </Dropdown>
                      <span className="ml-4 fs-23 mr-3"></span>
                      <div className="buttons-container textsearch">
                        <ul className="d-flex mt-1  m-mt">
                          <li>
                            <a
                              className=" mr-2"
                              href="#"
                              id=""
                              role="button"
                              data-toggle=""
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i
                                className="right-icons las la-tags"
                                aria-hidden="true"
                                onClick={tagPage}
                              ></i>
                            </a>
                          </li>

                          <li>
                            <a
                              className=" mr-2"
                              href="#"
                              id=""
                              role="button"
                              data-toggle=""
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i
                                className="right-icons la la-file-excel"
                                aria-hidden="true"
                                onClick={downloadExcel}
                              ></i>
                            </a>
                          </li>
                          <li>
                            <a
                              className=" mr-2"
                              role="button"
                              data-toggle=""
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClick={downloadPDF}
                            >
                              <i
                                className="right-icons la la-file-pdf"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                          <li>
                            <a
                              className=" mr-2"
                              role="button"
                              data-toggle=""
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClick={printPage}
                            >
                              <i
                                className="right-icons la la-print"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </li>
                        </ul>
                        <Search
                          placeholder="Search"
                          allowClear
                          onChange={onSearch}
                          style={{ width: 200 }}
                        />
                        <FeatureComingSoon>
                          <Button className="d-none d-sm-inline-block ml-2 btn-outline-grey">
                            <i className="fas fa-bolt pr-1"></i> CONNECT TO CRM
                          </Button>
                        </FeatureComingSoon>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-container text-nowrap">
                        <div className="table-wrapper">
                          {!loading ? (
                            <Table
                              rowSelection={{
                                type: "checkbox",
                                ...rowSelection,
                              }}
                              columns={columns}
                              dataSource={executiveEmployeeList}
                              pagination={{
                                responsive: true,
                                defaultCurrent: paginationValue?.start + 1,
                                total: companyFilterList?.totalExecutiveCount,
                                pageSize:
                                  parseInt(PAGE_LENGTH) >
                                  parseInt(
                                    companyFilterList?.totalExecutiveCount
                                  )
                                    ? companyFilterList?.totalExecutiveCount
                                    : paginationValue.end
                                      ? paginationValue.end
                                      : PAGE_LENGTH,
                                position: ["bottomCenter"],
                                onChange: onPageChange,
                              }}
                            />
                          ) : (
                            <Loader />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ImportLeads open={isImport} handleCancel={() => setImport(false)} />
    </>
  );
};
export default LeadTableView;
